import {DisplaySizeFilter} from "@/poster-gallery/classes/display-size-filter";
import {initPosterGalleryObj} from "@/poster-gallery/components/init-poster-gallery-slice.js";

const closeSubsizesListSelector = '.js-close-subsizes-list',
    showDisplaySubsizesSelector = '.js-show-display-subsizes',
    gridMasonrySelector = '.js-grid-masonry',
    visibleGridMasonrySelector = `${gridMasonrySelector}:visible`,
    sidebarSelector = '.js-gallery-sidebar',
    /**
     * @var {jQuery}
     */
    pageGrid = $('.js-page-grid'),
    doc = $(document),
    INNER_SIDEBAR_DEBOUNCE = 20;

initPosterGalleryObj();
const isGalleryPage = PMW.posterGallery.isDynamicGalleryPage();

$(function () {
    PMW.onClick(doc, showDisplaySubsizesSelector, onClickShowDisplaySubsizes);
    PMW.onClick(doc, closeSubsizesListSelector, onClickSubsizesCloseButton);
    initSidebarHeightIfNeeded();
    attachSidebarInnerScrollHandler();

    const displaySizeFilter = DisplaySizeFilter.fromPageHtml();
    displaySizeFilter.updateView();

    const displaySizeWithActiveSubsize = $('.js-size-filter.-display-size-with-active-subsize');
    openDisplaySubsizesListForDisplaySize(displaySizeWithActiveSubsize);
});

/**
 * If a size with subsizes is selected from the sidebar
 * we open the subsizes list for the parent display size
 *
 * @param {jQuery} displaySize
 */
function openDisplaySubsizesListForDisplaySize(displaySize) {
    const displaySizeOptionContainer = displaySize.closest('.js-size-filter');

    if (!displaySizeOptionContainer.hasClass('-subsize')) {
        displaySizeOptionContainer.find(showDisplaySubsizesSelector).trigger(PMW.click);
    }
}

/**
 * @param {Event} e
 */
function onClickShowDisplaySubsizes(e) {
    e.stopPropagation();
    const chosenDisplaySize = $(this).closest('.js-size-filter');

    if (!chosenDisplaySize.hasClass('-has-subsizes')) {
        return;
    }
    const displaySizeUri = chosenDisplaySize.attr('data-size-name'),
        allDisplaySizes = $('.js-sizes-sidebar .js-size-filter').not('.-subsize'),
        subsizesContainers = $('.js-subsizes-container'),
        subsizesListToShow = $(`.js-subsizes-container[data-parent-size-name=${displaySizeUri}]`),
        sizesSidebar = $('.js-sizes-sidebar'),
        sizesHeaderText = $('.js-sizes-header-text'),
        chosenDisplaySizeDisplayName = chosenDisplaySize.find('.js-size-display-name').text(),
        visibleMasonryGrid = $(visibleGridMasonrySelector);

    if (chosenDisplaySize.hasClass('js-mobile-size-option')) {
        const subsizesPanel = $(`.js-display-subsize-panel-${displaySizeUri}`);

        if (typeof PMW?.posterGallery?.showMobileFiltersPanel !== 'undefined') {
            PMW.posterGallery.showMobileFiltersPanel(subsizesPanel);
            clickAllSubsizesOptionIfNeeded(chosenDisplaySize, subsizesPanel);
        }
        return;
    }

    allDisplaySizes.removeClass('list-item-visible').addClass('hide-list-item');
    subsizesContainers.removeClass('list-item-visible').addClass('hide-list-item');
    subsizesListToShow.removeClass('hide-list-item').addClass('list-item-visible');
    sizesSidebar.addClass('-showing-subsizes');
    sizesHeaderText.text(chosenDisplaySizeDisplayName);
    layoutMasonryGrid(visibleMasonryGrid);

    if (!isSizesListVisible()) {
        PMW.util.smoothScrollTo(pageGrid);
    }
    clickAllSubsizesOptionIfNeeded(chosenDisplaySize, subsizesListToShow)
}

/**
 * Checks if the sizes list is visible on-screen
 */
function isSizesListVisible() {
    const flyoutSearchField = $('.js-page-top-search-field'),
        isFlyoutVisible = flyoutSearchField.is(':visible'),
        sidebar = $('.js-sizes-sidebar'),
        sidebarTopOffset = sidebar.offset().top,
        sidebarHeight = sidebar.innerHeight();

    let hiddenPixelsOfSidebar = (window.scrollY - sidebarTopOffset);

    if (isFlyoutVisible) {
        hiddenPixelsOfSidebar += flyoutSearchField.outerHeight();
    }
    return (hiddenPixelsOfSidebar < sidebarHeight);
}

/**
 * If the user opens a subsizes list and no subsize is selected, we manually
 * select the 'all' option
 *
 * @param {jQuery} chosenDisplaySize
 * @param {jQuery} subsizesListContainer
 */
function clickAllSubsizesOptionIfNeeded(chosenDisplaySize, subsizesListContainer) {
    if (!isGalleryPage) {
        return;
    }

    if (DisplaySizeFilter.isChosenDisplaySizeActive(chosenDisplaySize)) {
        return;
    }
    const allSubsizesOption = subsizesListContainer.find('.js-all-subsizes-option');
    allSubsizesOption.find('.js-size-href').trigger({
        type: PMW.click,
        detail: {
            isClickManuallyTriggered: true,
        }
    });
}

function onClickSubsizesCloseButton() {
    const allDisplaySizes = $('.js-sizes-sidebar .js-size-filter').not('.-subsize'),
        subsizesContainers = $('.js-subsizes-container'),
        sizesSidebar = $('.js-sizes-sidebar'),
        sizesHeaderText = $('.js-sizes-header-text');

    allDisplaySizes.removeClass('hide-list-item').addClass('list-item-visible');
    subsizesContainers.removeClass('list-item-visible').addClass('hide-list-item');
    sizesSidebar.removeClass('-showing-subsizes');
    sizesHeaderText.text($('.sizes-header').attr('data-default-text'));
    $(visibleGridMasonrySelector).masonry('layout');
}

function onSidebarInnerScroll() {
    const sidebar = $(sidebarSelector),
        sizesHeader = sidebar.find('.sizes-header');

    sizesHeader.toggleClass('-stuck', sidebar.get(0).scrollTop > 0);
}

function initSidebarHeightIfNeeded() {
    if (isGalleryPage) {
        PMW.unifiedGallery.initSidebarHeight();
    }
}

/**
 * @param {jQuery|*} grid
 */
const layoutMasonryGrid = (grid) => {
    if (grid.attr('data-is-masonry-loaded') === '1') {
        grid.masonry('layout');
    } else {
        document.addEventListener('masonry-loaded', () => {
            grid.masonry('layout');
        }, {once: true});
    }
}

export function toggleSidebarWidth() {
    pageGrid.find('.js-sidebar-container').toggleClass('-less-wide', PMW.util.isInGalleryDialog());
}

export function attachSidebarInnerScrollHandler() {
    $(sidebarSelector).on('scroll', PMW.debounce(onSidebarInnerScroll, INNER_SIDEBAR_DEBOUNCE));
}

PMW.onClickSubsizesCloseButton = onClickSubsizesCloseButton;